import { render } from "./SidebarMenu.vue?vue&type=template&id=3cc9e6c9&scoped=true"
import script from "./SidebarMenu.vue?vue&type=script&lang=js"
export * from "./SidebarMenu.vue?vue&type=script&lang=js"

import "./SidebarMenu.vue?vue&type=style&index=0&id=3cc9e6c9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3cc9e6c9"

export default script